module.exports = __webpack_public_path__ + "img/icon-A.45ba5762.svg";